module.exports = __webpack_public_path__ + "img/universkinLogo.9134225f.png";